import { Flex, HStack, Icon, Text } from '@chakra-ui/react';
import { MdCancel, MdCheckCircle } from 'react-icons/md';

function PasswordValidationItem({ isValid, children }) {
    return (
        <HStack spacing={2} align="center">
            <Flex justifyContent="center">
                {isValid ? (
                    <Icon as={MdCheckCircle} color="green.500" boxSize="14px" />
                ) : (
                    <Icon as={MdCancel} color="red.500" boxSize="14px" />
                )}
            </Flex>
            <Text fontSize="sm" color={isValid ? 'green.600' : 'red.600'}>
                {children}
            </Text>
        </HStack>
    );
}

export { PasswordValidationItem };
